import { render, staticRenderFns } from "./HistoricalContent.vue?vue&type=template&id=8d133908&"
import script from "./HistoricalContent.vue?vue&type=script&lang=js&"
export * from "./HistoricalContent.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalContent.vue?vue&type=style&index=0&id=8d133908&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports